import type { Technique } from '../types';
import { LSYSTEM_TREE_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type LSystemTreeState } from './render';

export const lsystemTree: Technique<LSystemTreeState> = {
  id: 'lsystem-tree',
  name: 'Baum mit Buchstaben-Blättern',
  category: 'growth',
  description:
    'Rekursives Astwerk, an dessen Spitzen die Buchstaben als Blätter hängen. Wirkt am stärksten mit ausgeblendetem Text-Layer.',
  params: LSYSTEM_TREE_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
